import React, { useEffect, useState, useMemo } from "react";
import { Line, Bar, HorizontalBar } from "react-chartjs-2";
import "./mainDashboard.css";
import { DatePicker, Select, Spin, Modal, Icon, Skeleton } from "antd";
import moment from "moment";
import { useTheme } from "../../utils/ThemeContext";
import { MODULE_API } from "../../apis";
import DASHBOARD_API from "../../apis/dashboard.api";
import DEATH_API from "../../apis/death.api";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";
const { Option } = Select;

export const TopMonthlyExpanse = ({ originalSetting }) => {
  const { theme } = useTheme();

  const monthsFilter = [
    {
      id: 1,
      filter: "This Month",
    },
    {
      id: 2,
      filter: "Compare Last Month",
    },
    {
      id: 3,
      filter: "Compare Last Year",
    },
  ];
  // State to track settings directly, allows us to trigger updates manually
  const [settings, setSettings] = useState(() => {
    const raw = localStorage.getItem("setting");
    return raw && raw !== "undefined" ? JSON.parse(raw) : null;
  });

  // Listen for storage changes to keep settings in sync across different components
  useEffect(() => {
    const handleStorageChange = () => {
      const raw = localStorage.getItem("setting");
      if (raw && raw !== "undefined") {
        setSettings(JSON.parse(raw));
      }
    };
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("settingsUpdated", handleStorageChange); // Custom event for same-window updates
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("settingsUpdated", handleStorageChange);
    };
  }, []);

  // Track the ID string of the last source we synced from to detect external changes
  const [lastSyncedIds, setLastSyncedIds] = useState("");

  const [compareFilter, setCompareFilter] = useState("This Month");
  const [loading, setLoading] = useState(false);
  const [topExpanse, setTopExpanse] = useState([]);
  const [currentMonthTopExpanse, setCurrentMonthTopExpanse] = useState([]);
  const [currentYearTopExpanse, setCurrentYearTopExpanse] = useState([]);
  const [editBalance, setEditBalance] = useState(false);
  const [assetsToSelect, setAssetsToSelect] = useState([]);
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [userSelectedAssets, setUserSelectedAssets] = useState([]);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // Combine assets from API with already saved assets from settings
  // to ensure names are shown immediately instead of IDs
  const combinedAssets = useMemo(() => {
    const list = [...(assetsToSelect || [])];
    const userAssets = userSelectedAssets || [];
    userAssets.forEach((userAsset) => {
      if (!list.some((apiAsset) => apiAsset.id === userAsset.id)) {
        list.push(userAsset);
      }
    });
    return list;
  }, [assetsToSelect, userSelectedAssets]);

  const handlePopupScroll = (e) => {
    const { target } = e;
    if (
      !loading &&
      hasMore &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 10
    ) {
      const nextPage = page + 1;
      getAssetsList(nextPage, true);
    }
  };

  const getAssetsList = async (pageNum = 1, isAppending = false) => {
    try {
      setLoading(true);
      let datares = await DASHBOARD_API.fetchLiquidAssetsPlaid(pageNum);
      console.log("getAssetsList Liquid", datares);
      if (datares && datares.records) {
        setAssetsToSelect((prevAssets) =>
          isAppending ? [...prevAssets, ...datares.records] : datares.records
        );
        setPage(pageNum);
      }
      if (datares && datares.pagination) {
        const { limit, total } = datares.pagination;
        setHasMore(pageNum * limit < total);
      } else {
        setHasMore(false);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getTopExpanse = async (payload) => {
    try {
      setLoading(true);
      // setCurrentMonthTopExpanse([]);
      // let payload = {
      //   startDate: startDate,
      //   endDate: endDate,
      //   cmIds: selectedAssets,
      // };
      let data = await MODULE_API.getTopExpanses(payload);
      if (data && data.data) {
        setTopExpanse(data.data);
        return data.data;
      }
      return [];
    } catch (error) {
      console.log(error);
      return [];
    } finally {
      setLoading(false);
    }
  };
  const updateUserLiquidAssetAvailable = async () => {
    try {
      setLoading(true);
      const filteredAssets =
        combinedAssets &&
        combinedAssets
          .filter((asset) => selectedAssets.includes(asset.id))
          .map((asset) => {
            return {
              id: asset.id,
              "Name of Asset":
                asset["Name of Asset"] ||
                asset["Nickname of Liabilities"] ||
                asset["Nickname of Credit"],
            };
          });
      // const filteredAssetIds =
      //   assetsToselect &&
      //   assetsToselect
      //     .filter((asset) => selectedAssets.includes(asset["Name of Asset"]))
      //     .map((asset) => asset.id);

      let payload = {
        ...(originalSetting || settings),
        topMonthlyExpanse: filteredAssets,
        updatedDate: new Date(),
      };
      setUserSelectedAssets(filteredAssets);
      let data = await DEATH_API.updateUserAssetSetting(payload);
      if (data && data.status === 200) {
        const date = moment();
        const startDate = date.startOf("month").format("YYYY-MM-DD");
        const endDate = date.endOf("month").format("YYYY-MM-DD");
        let payload = {
          startDate: startDate,
          endDate: endDate,
          cmIds: selectedAssets,
        };
        await getTopExpanse(payload);
        setCompareFilter("This Month");

        // Update local storage and notify the component to refresh its state
        localStorage.setItem("setting", JSON.stringify(data.data));
        window.dispatchEvent(new Event("settingsUpdated"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const callFilter = async (startDate, endDate) => {
    const payload = {
      startDate: startDate,
      endDate: endDate,
      cmIds: selectedAssets || [],
    };
    await getTopExpanse(payload);
  };
  useEffect(() => {
    // const date = moment();
    // const startDate = date.startOf("month").format("YYYY-MM-DD");
    // const endDate = date.endOf("month").format("YYYY-MM-DD");
    getAssetsList();
    // callFilter(startDate, endDate);
  }, []);

  useEffect(() => {
    editBalance && getAssetsList();
  }, [editBalance]);

  useEffect(() => {
    // Priority: originalSetting if it has data, otherwise fallback to local settings
    const source =
      originalSetting &&
        originalSetting.topMonthlyExpanse &&
        originalSetting.topMonthlyExpanse.length > 0
        ? originalSetting.topMonthlyExpanse
        : settings &&
          settings.topMonthlyExpanse &&
          settings.topMonthlyExpanse.length > 0
          ? settings.topMonthlyExpanse
          : [];

    const newSourceIds = (source || []).map((asset) => asset.id).join(",");

    // Only update state if the EXTERNAL source (props or settings) has actually changed.
    // This prevented the bug where manual user selections were being overwritten.
    if (newSourceIds !== lastSyncedIds) {
      if (source && source.length > 0) {
        const filteredAssetIds = source.map((asset) => asset.id);
        setSelectedAssets(filteredAssetIds);
        setUserSelectedAssets(source);

        const date = moment();
        const startDate = date.startOf("month").format("YYYY-MM-DD");
        const endDate = date.endOf("month").format("YYYY-MM-DD");
        let payload = {
          startDate: startDate,
          endDate: endDate,
          cmIds: filteredAssetIds,
        };
        getTopExpanse(payload);
      }
      setLastSyncedIds(newSourceIds);
    }
  }, [originalSetting, settings, lastSyncedIds]);
  const filterData = async (selectedFilter) => {
    let startDate, endDate;
    const date = moment();

    switch (selectedFilter) {
      case "Current Month":
        startDate = date.startOf("month").format("YYYY-MM-DD");
        endDate = date.endOf("month").format("YYYY-MM-DD");
        break;
      case "This Month":
        startDate = date.startOf("month").format("YYYY-MM-DD");
        endDate = date.endOf("month").format("YYYY-MM-DD");
        break;
      case "This month to last month":
        startDate = date
          .clone()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = date.endOf("month").format("YYYY-MM-DD");
        break;
      case "Compare Last Month":
        startDate = date
          .clone()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = date
          .clone()
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;

      case "Compare Last Year":
        startDate = date
          .clone()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD");
        endDate = date.endOf("year").subtract(1, "year").format("YYYY-MM-DD");
        break;

      case "Compare Last Yearasas":
        startDate = date
          .clone()
          .subtract(1, "year")
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = date
          .clone()
          .subtract(1, "year")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;

      default:
        startDate = date.startOf("month").format("YYYY-MM-DD");
        endDate = date.endOf("month").format("YYYY-MM-DD");
    }
    if (selectedFilter == "Compare Last Month") {
      let currentMonthStartDate = date.startOf("month").format("YYYY-MM-DD");
      let currentMonthEndDate = date.endOf("month").format("YYYY-MM-DD");
      let payload = {
        startDate: currentMonthStartDate,
        endDate: currentMonthEndDate,
        cmIds: selectedAssets,
      };
      let response = await getTopExpanse(payload);
      setCurrentMonthTopExpanse(response);
      let payload2 = {
        startDate: startDate,
        endDate: endDate,
        cmIds: selectedAssets,
      };
      await Promise.allSettled([getTopExpanse(payload2)]);
    } else if (selectedFilter == "Compare Last Year") {
      const currentDate = moment();
      let currentYearStartDate = currentDate
        .clone()
        .startOf("year")
        .format("YYYY-MM-DD");
      let currentYearEndDate = currentDate
        .clone()
        .endOf("year")
        .format("YYYY-MM-DD");
      let payloadLastYear = {
        startDate: currentYearStartDate,
        endDate: currentYearEndDate,
        cmIds: selectedAssets,
      };
      let response = await getTopExpanse(payloadLastYear);
      setCurrentYearTopExpanse(response);
      let payloadLastYear2 = {
        startDate: startDate,
        endDate: endDate,
        cmIds: selectedAssets,
      };
      await Promise.allSettled([getTopExpanse(payloadLastYear2)]);
    } else {
      let payloadLast = {
        startDate: startDate,
        endDate: endDate,
        cmIds: selectedAssets,
      };
      await Promise.allSettled([getTopExpanse(payloadLast)]);
    }
  };
  const handleSave = async () => {
    setEditBalance(false);
    await updateUserLiquidAssetAvailable();
    // setSelectedAssets([]);
  };
  const handleCancel = () => {
    // setSelectedAssets([]);
    setEditBalance(false);
  };

  const options = {
    plugins: {
      datalabels: {
        display: true,
        color: "white",
        formatter: (value, context) => `${value}%`,
      },
    },
    tooltip: {
      callbacks: {
        title: (tooltipItems) => {
          const index = tooltipItems[0].dataIndex;
          return uniqueItemNames[index]; // Show full name on hover
        },
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback: function (value) {
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value);
            },
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            autoSkip: false,
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
        },
      ],
    },
  };
  const currentMonth = moment().format("MMM YYYY");
  const lastMonth = moment().subtract(1, "months").format("MMM YYYY");
  const currentYear = moment().format("YYYY");
  const lastYear = moment().subtract(1, "years").format("YYYY");

  const labels =
    topExpanse &&
    topExpanse.map((item) => {
      const maxLength = 40; // Set your desired max length here
      const itemName = item.itemName || "Unknown Item";
      return itemName.length > maxLength
        ? `${itemName.slice(0, maxLength)}...`
        : itemName;
    });

  const amounts =
    topExpanse &&
    topExpanse.map((item) => (item.amount ? Math.abs(item.amount) : 0));
  // negative amount need to be handle here

  const labelsDataSet2 =
    currentYearTopExpanse &&
    currentYearTopExpanse.map((item) => item.itemName || "Unknown Item");
  const dataSet2Amount =
    compareFilter === "Compare Last Month"
      ? currentMonthTopExpanse
      : compareFilter === "Compare Last Year"
        ? currentYearTopExpanse
        : [];
  const amountsDataSet2 = (dataSet2Amount || []).map(
    (item) => item.amount || 0
  );
  console.log(
    "amountsssss",
    amounts,
    amountsDataSet2,
    labels,
    topExpanse,
    currentMonthTopExpanse,
    currentYearTopExpanse
  );

  const dataSetToCompare =
    compareFilter === "Compare Last Month"
      ? currentMonthTopExpanse
      : compareFilter === "Compare Last Year"
        ? currentYearTopExpanse
        : []; // Default to empty array if neither condition is met

  // Get the unique item names from both datasets
  const topExpanseItemNames =
    topExpanse && new Set(topExpanse.map((item) => item.itemName));
  const compareItemNames =
    dataSetToCompare && new Set(dataSetToCompare.map((item) => item.itemName));

  // Create an array with all unique item names from both datasets
  const uniqueItemNames =
    topExpanseItemNames && compareItemNames
      ? Array.from(new Set([...topExpanseItemNames, ...compareItemNames]))
      : [];

  // Map the amounts for each dataset based on the unique item names
  const amountsForTopExpanse =
    uniqueItemNames &&
    uniqueItemNames.map((itemName) => {
      const matchedItem =
        topExpanse && topExpanse.find((item) => item.itemName === itemName);
      return matchedItem
        ? matchedItem.amount && Math.abs(matchedItem.amount)
        : 0; // If no match, set amount to 0
    });

  const amountsForCompareDataset =
    uniqueItemNames &&
    uniqueItemNames.map((itemName) => {
      const matchedItem = dataSetToCompare.find(
        (item) => item.itemName === itemName
      );
      return matchedItem
        ? matchedItem.amount && Math.abs(matchedItem.amount)
        : 0; // If no match, set amount to 0
    });
  console.log(
    "Unique Item Names:",
    uniqueItemNames,
    amountsForCompareDataset,
    amountsForTopExpanse
  );
  const chartData = {
    labels,
    datasets: [
      {
        label: "This Month",
        data: amounts,
        backgroundColor: "#2A3DA3",
      },
    ],
  };
  const formatLabel = (itemName) =>
    itemName && itemName.length > 40 ? `${itemName.slice(0, 37)}...` : itemName;
  // const displayLabels = uniqueItemNames && uniqueItemNames.map(formatLabel);
  const displayLabels =
    compareFilter === "Compare Last Year"
      ? ["Expense"]
      : uniqueItemNames && uniqueItemNames.map(formatLabel);
  const sumArray = (arr) =>
    Array.isArray(arr) ? [arr.reduce((sum, val) => sum + val, 0)] : [];
  const chartDataCompare = {
    labels: displayLabels ? displayLabels : [],
    datasets: [
      {
        label:
          compareFilter === "Compare Last Month" ? currentMonth : currentYear,
        // data: amountsForCompareDataset ? amountsForCompareDataset : [],
        data: amountsForCompareDataset
          ? compareFilter === "Compare Last Year"
            ? sumArray(amountsForCompareDataset)
            : amountsForCompareDataset
          : [],
        backgroundColor: "#2A3DA3",
      },
      {
        label: compareFilter === "Compare Last Month" ? lastMonth : lastYear,
        // data: amountsForTopExpanse ? amountsForTopExpanse : [],
        data: amountsForTopExpanse
          ? compareFilter === "Compare Last Year"
            ? sumArray(amountsForTopExpanse)
            : amountsForTopExpanse
          : [],
        backgroundColor: "#B1E3FF",
      },
    ],
  };

  return (
    <div
      className="SavingMainCard2"
      style={{
        position: "relative",
        width: "100%",
        padding: "0px",
        borderRadius: "0px",
        backgroundColor: theme === "dark" ? "#232323" : "white",
      }}
    >
      <h1
        className="SavingCardheading"
        style={{
          marginBottom: "8px",
          color: theme === "light" ? "#232323" : "white",
        }}
      >
        Top 5 Monthly Expenses
      </h1>
      {/*<ToolTipCreator name="test Tootip" />*/}
      <div
        className="compareSelectContainer "
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "space-between",
          gap: "1rem",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "8px",
            alignItems: "center",
          }}
        >
          {" "}
          <h3 className="modaltitle">Edit Monthly Expenses </h3>
          {localStorage.getItem("role") &&
            JSON.parse(localStorage.getItem("role")) !==
            "Financial Advisor Client" && (
              <Icon
                type="edit"
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  color: "#2a3da3",
                }}
                onClick={() => {
                  setEditBalance(true);
                }}
              />
            )}
        </div>
        <Modal visible={editBalance} footer={null} closable={false} centered>
          <h3 className="modaltitle">Edit Top 5 Monthly Expenses</h3>
          <h3 className="modaltitle" style={{ fontSize: "14px" }}>
            Select Assets to Calculate Top 5 Monthly Expenses
          </h3>
          <h3 className="inputTitle">All Assets</h3>
          <Select
            mode="multiple"
            showSearch
            style={{ width: "100%" }}
            placeholder="Select Assets"
            onPopupScroll={handlePopupScroll} // Pagination on scroll
            // value={selectedAssets && selectedAssets}
            value={selectedAssets || []}
            onChange={(value) => {
              console.log("value", value);
              setSelectedAssets(value);
            }}
            notFoundContent={loading ? <Spin /> : null}
            optionLabelProp="label"
          >
            {combinedAssets &&
              combinedAssets.map((asset, index) => (
                <Option
                  key={asset.id}
                  value={asset.id}
                  label={
                    asset["Name of Asset"] ||
                    asset["Nickname of Liabilities"] ||
                    asset["Nickname of Credit"]
                  }
                >
                  <span
                    role="img"
                    aria-label={
                      asset["Name of Asset"] ||
                      asset["Nickname of Liabilities"] ||
                      asset["Nickname of Credit"]
                    }
                    style={{ marginRight: "8px" }}
                  >
                    {asset.image && (
                      <img
                        width={32}
                        src={asset.image}
                        alt={
                          asset["Name of Asset"] ||
                          asset["Nickname of Liabilities"] ||
                          asset["Nickname of Credit"]
                        }
                      ></img>
                    )}
                  </span>
                  {asset["Name of Asset"] ||
                    asset["Nickname of Liabilities"] ||
                    asset["Nickname of Credit"]}
                </Option>
              ))}
          </Select>
          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancel();
              }}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              onClick={() => {
                handleSave();
              }}
            >
              Save
            </button>
          </div>
        </Modal>
        <div className="compareSelect">
          {monthsFilter &&
            monthsFilter.map((item, index) => (
              <div
                key={index}
                className={
                  item.filter === compareFilter
                    ? "selectedfilter"
                    : "unSelectedfilter"
                }
                onClick={() => {
                  setCompareFilter(item.filter);
                  filterData(item.filter);
                }}
              >
                {item.filter}
              </div>
            ))}
        </div>
      </div>

      <div
        className="parentHorizontalBarAndImage"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          marginTop: "10px",
          height: "330px",
        }}
      >
        {topExpanse && topExpanse.length > 0 ? (
          <HorizontalBar
            options={options}
            data={compareFilter === "This Month" ? chartData : chartDataCompare}
          />
        ) : (
          <span
            style={{
              color: theme === "light" ? "#232323" : "#ffffff",
            }}
            className="noDataToShow"
          >
            No Expense To Show
          </span>
        )}
        {/*topExpanse && topExpanse.length > 0 ? (
          topExpanse.map((item, index) => {
            const compareData =
              compareFilter === "Compare Last Month"
                ? currentMonthTopExpanse
                : compareFilter === "Compare Last Year"
                ? currentYearTopExpanse
                : [];

            // Find matching category in the compareData
            const matchingCategory =
              compareData &&
              compareData.find(
                (compareItem) =>
                  compareItem.category_from_plaid === item.category_from_plaid
              );
            const currentMonth = moment().format("MMM YYYY");
            const lastMonth = moment().subtract(1, "months").format("MMM YYYY");
            const currentYear = moment().format("YYYY");
            const lastYear = moment().subtract(1, "years").format("YYYY");
            const matchingAsset =
            userSelectedAssets &&
            userSelectedAssets.find(
              (compareItem) =>
                compareItem.id === item.liquid_asset_id
            );
            return (
              <div
                key={index}
                className="HorizontalBarAndImage"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {compareFilter !== "Today" && (
                  <img
                    src="/static/media/asset.cb8cfc4b.png"
                    height="40px"
                    alt="Assets"
                  />
                )}
                {compareFilter === "Today" && (
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "15.6px",
                      textAlign: "left",
                      color: theme === "light" ? "#232323" : "white",
                      padding: "0px",
                      margin: "0px",
                      marginLeft: "10px",
                      width: "100px",
                    }}
                  >
                    {(matchingAsset && matchingAsset["Name of Asset"]) ||
                      "N/A"}
                  </p>
                )}
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    {compareFilter !== "Today" && (
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "15.6px",
                          textAlign: "left",
                          color: theme === "light" ? "#232323" : "white",
                          padding: "0px",
                          margin: "0px",
                          marginLeft: "10px",
                          width: "100px",
                        }}
                      >
                        {(compareFilter === "Compare Last Month"
                          ? currentMonth
                          : currentYear) || "N/A"}
                      </p>
                    )}
                    <div
                      className="HorizontalBarAndImage"
                      style={{
                        backgroundColor: "rgb(192, 192, 192)",
                        width: "100%",
                        borderRadius: "3px",
                        height: "19px",
                        marginLeft: "10px",
                      }}
                    >
                      <div
                        className="HorizontalBarAndImage"
                        style={{
                          backgroundColor: "rgb(42, 61, 163)",
                          color: "white",
                          padding: "1%",
                          textAlign: "right",
                          fontSize: "12px",
                          borderRadius: "3px",
                          width: `${
                            item.total_amount
                              ? Math.min(
                                  100,
                                  Math.max(
                                    0,
                                    (item.budget_amount / item.total_amount) *
                                      100
                                  )
                                )
                              : 0
                          }%`,
                          height: "19px",
                          display: "flex",
                          alignContent: "center",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        {item.total_amount &&
                          item.total_amount
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </div>
                    </div>
                    {compareFilter !== "Today" && (
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "15.6px",
                          textAlign: "left",
                          color: theme === "light" ? "#232323" : "white",
                          padding: "0px",
                          margin: "0px",
                          marginLeft: "10px",
                          width: "100px",
                        }}
                      >
                        {(matchingAsset &&
                           matchingAsset["Name of Asset"]) ||
                          "N/A"}
                      </p>
                    )}
                  </div>
                   Second Progress Bar for Compare Filters 
                  {compareFilter !== "Today" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      {compareFilter !== "Today" && (
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            lineHeight: "15.6px",
                            textAlign: "left",
                            color: theme === "light" ? "#232323" : "white",
                            padding: "0px",
                            margin: "0px",
                            marginLeft: "10px",
                            width: "100px",
                          }}
                        >
                          {(compareFilter === "Compare Last Month"
                            ? lastMonth
                            : lastYear) || "N/A"}
                        </p>
                      )}
                      <div
                        className="HorizontalBarAndImage"
                        style={{
                          backgroundColor: "rgb(192, 192, 192)",
                          width: "100%",
                          borderRadius: "3px",
                          height: "19px",
                          marginLeft: "10px",
                        }}
                      >
                        <div
                          className="HorizontalBarAndImage"
                          style={{
                            backgroundColor: "rgb(42, 61, 163)",
                            color: "white",
                            padding: "1%",
                            textAlign: "right",
                            fontSize: "12px",
                            borderRadius: "3px",
                            width: `${
                              matchingCategory
                                ? Math.min(
                                    100,
                                    Math.max(
                                      0,
                                      ((matchingCategory.budget_amount ?  matchingCategory.budget_amount : 0) /
                                        (matchingCategory.total_amount ? matchingCategory.total_amount : 0)) *
                                        100
                                    )
                                  )
                                : 0
                            }%`,
                            height: "19px",
                            display: "flex",
                            alignContent: "center",
                            alignItems: "center",
                            justifyContent: "flex-end",
                          }}
                        >
                          {matchingCategory && (matchingCategory.total_amount && matchingCategory.total_amount)
                            ? (matchingCategory.total_amount)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>
                      {compareFilter !== "Today" && (
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            lineHeight: "15.6px",
                            textAlign: "left",
                            color: theme === "light" ? "#232323" : "white",
                            padding: "0px",
                            margin: "0px",
                            marginLeft: "10px",
                            width: "100px",
                          }}
                        >
                          {(matchingAsset &&
                            matchingAsset["Name of Asset"]) ||
                            "N/A"}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <span
            style={{
              color: theme === "light" ? "#232323" : "#ffffff",
            }}
            className="noDataToShow"
          >
            No Expense To Show
          </span>
        )*/}
      </div>

      {loading && (!topExpanse || topExpanse.length === 0) ? (
        <Skeleton active paragraph={{ rows: 7 }} title={false} />
      ) : null}
      {loading && topExpanse && topExpanse.length > 0 ? (
        <div style={{ marginTop: "12px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "64px", borderRadius: "12px", border: "1px solid rgba(74, 98, 255, 0.35)", background: "linear-gradient(135deg, rgba(42, 61, 163, 0.16), rgba(42, 61, 163, 0.06))", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.14)" }}>
          <Spin size="large" />
        </div>
      ) : null}
    </div>
  );
};
